var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('banner-wrapper',{attrs:{"wrapperText":_vm.wrapperText}}),_c('TopNav',{attrs:{"list":_vm.nav}}),_c('AboutUs',{attrs:{"id":"vision"}}),_c('Vision'),_c('Resource'),_c('Development'),_c('Join',{attrs:{"id":"join"}}),_c('Recruit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }